import React, { useState, useEffect } from 'react'
import Flatpickr from "react-flatpickr";
import Select from "react-select";

export default function DonationModal({handleClose, saving, handleAddItem }) {
    const [donation, setDonation] = useState({
        name: '',
        description: '',
        unit_cost: 0.00,
        currency: ''
    })
    let currencyOptions = [
        {id: 1, currency: 'USD'}
    ]
    const [selectedCurrencyType, setSelectedCurrencyType] = useState(currencyOptions[0])
    const [save, setSave] = useState(false)

    // guard against paying more than the invoice
    useEffect(() => {
        setDonation({...donation, currency: selectedCurrencyType.currency})
    }, [selectedCurrencyType])

  return (
    <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
                <div className="bg-white mx-auto rounded shadow p-5 text-center cu-width-input">
                    <div>
                    <div class="row">
                        <div class="col-md-12">
                            <div className="form-group rd-pad-in">
                                    <label htmlFor="invoice_number">Name</label>
                                    <input
                                        className="form-control"
                                        placeholder="Name"
                                        type="text"
                                        name="invoice_number"
                                        id="invoice_number"
                                        value={donation.name}
                                        onChange={(e) => {
                                        setDonation({...donation, name: e.target.value})
                                        }}
                                    />
                            </div>

                            <div className="form-group rd-pad-in">
                                    <label htmlFor="invoice_number">Description</label>
                                    <input
                                        className="form-control"
                                        placeholder="Description"
                                        type="text"
                                        name="invoice_number"
                                        id="invoice_number"
                                        value={donation.description}
                                        onChange={(e) => {
                                        setDonation({...donation, description: e.target.value})
                                        }}
                                    />
                            </div>

                            <div className="form-group rd-pad-in">
                                    <label htmlFor="invoice_number">Unit Cost</label>
                                    <input
                                        className="form-control"
                                        placeholder="0.00"
                                        type="number"
                                        name="invoice_number"
                                        id="invoice_number"
                                        value={donation.unit_cost}
                                        onChange={(e) => {
                                        setDonation({...donation, unit_cost: parseFloat(e.target.value)})
                                        }}
                                    />
                            </div>

                        <div className="form-group">
                            <label>Payment Method</label>
                            <Select
                                className="form-control select-beneficiaries text-left"
                                classNamePrefix="select-beneficiaries"
                                onChange={(type) => setSelectedCurrencyType(type)}
                                options={currencyOptions}
                                getOptionLabel={(type) =>
                                    `${type.currency}`
                                }
                                getOptionValue={(type) => type.id}
                                value={selectedCurrencyType}
                            />
                        </div>

                        <div className="form-group align-items-center">
                                <input type="checkbox" checked={save} onChange={(e) => setSave(e.target.checked)} id="payment"/>
                                <label htmlFor="payment" style={{marginLeft: "5px"}}>Save to donations items list</label>
                        </div>

                        </div>
                    </div>
                    <span className="text-muted">Item will be available for this invoice only, unless the above checkbox is marked</span>
                    </div>
                    <div className="pt-3">
                        <button onClick={() => handleAddItem(donation, save)} type="button" className="btn btn-primary mr-2" disabled={saving}>
                        {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                            Create Item
                        </button>

                        <button onClick={handleClose} type="button" className="btn btn-secondary mr-2" disabled={saving}>
                            Cancel
                        </button>
                    </div>
                </div>
    </div>
    </div>
  )
}
